export const notSelected = [
  {
    label: 'all.contours',
    value: 'all',
  },
  {
    label: 'projected.contours',
    value: 'merged',
  },
  {
    label: 'undesigned.contours',
    value: 'unMerged',
  },
];
export const selected = [
  {
    label: 'projected.contours',
    value: 'merged',
  },
  {
    label: 'undesigned.contours',
    value: 'unMerged',
  },
  {
    label: 'selected.contours.for.the.project',
    value: 'selected',
  },
];
